import React from "react";

import "./styles.scss";

const Divider: React.FC = () => <div className="section-divider" />;

export default Divider;
